//import config from 'config';
//import { authHeader } from '../_helpers'; // bu da auth için

export const userService = {
    login,
    logout,
    handleResponse,
    sepetadet
};
import {helper} from '@/helper';
import { encode } from 'js-base64';
function login (username, password) {
    return new Promise(function(resolve,reject){
        let data = {kadi : username,pass: password}
        helper.request.post('login',data)
        .then(res => { 
            if (res.results.length>0) {
                let kullanici = {
                    u:res.results[0].uye_kod,
                    r:res.results[0].ref_kod,
                }
                let tkn = encode(username+','+password+','+res.results[0].uye_ad+','+res.results[0].ay+','+res.results[0].yil) // virgülle helperde parçalanıyor
                localStorage.setItem('tfx', JSON.stringify({
                    user:kullanici,
                    auth:tkn
                }));
                if(!localStorage.getItem('ayuBox')){
                    localStorage.setItem('ayuBox',JSON.stringify({"baskets":[]}))
                }
                resolve(true)
            }
            else {resolve(false)}
        })
        .catch(err => reject(err.message))
        });
}

function logout() {
    localStorage.removeItem('tfx');
    setTimeout(() => {location.reload(true);}, 100);
}

export default function handleResponse(username,password) { 
    // buradaki handleResponse main de helper yerine direkt bu isimle süslü parantezler içinde çekebilirmiyiz bir bakalım
    return new Promise(function(resolve,reject){
        let data = {kadi : username,pass: password}
          helper.request.post('login',data)
            .then(res => {
                if (res.results.length>0) {resolve(true)}
                else {reject(false)}
            })
            .catch(err => reject(err.message))
    });
}

function sepetadet(){
    return JSON.parse(localStorage.getItem('ayuBox')).baskets.length || 0
  }


// WEBPACK FOOTER //
// ./src/plugins/_services/user.service.js